import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "header-user-slice" }
const _hoisted_2 = {
  key: 0,
  class: "unlogged-section"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "logged-section"
}
const _hoisted_5 = { class: "user" }
const _hoisted_6 = { class: "user-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "user-identity-text" }
const _hoisted_9 = { class: "user-names" }
const _hoisted_10 = { key: 0 }

import {getSliceComponentProps} from '@prismicio/vue';
    import {computed, inject} from 'vue';
    import {HeaderUserSliceSlice} from '@/unlogged/prismicio';
    import {ServerSideNavigationPrismicLink, useUserInfoHelpers} from '@malt/vue-prismic';
    import {useUserData} from '@/unlogged/composables/useUserData';
    import {MICRO_FRONTEND} from '@/unlogged/keys';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: getSliceComponentProps<HeaderUserSliceSlice>(),
  setup(__props) {

    

    const isMicroFrontend = inject(MICRO_FRONTEND);

    const {isCompany} = useUserInfoHelpers();
    const userState = useUserData();
    const userData = computed(() => userState?.value?.data);
    const isLoading = computed(() => userState?.value?.isLoading);

    function getImage(url: string | undefined): string {
        return !url ? '' : `${url}?func=crop&w=60&h=60`;
    }

    function openSigninModal() {
        Hop.connect.control.showSigninPopup(document.body, false);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(userData) === undefined || !_unref(userData)?.isLoggedIn)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_unref(isLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(ServerSideNavigationPrismicLink), {
                  field: _ctx.slice.primary.signUpLink,
                  class: "sign-up-button",
                  "data-heap": _ctx.slice.primary.signUpHeapId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.slice.primary.signUpText), 1)
                  ]),
                  _: 1
                }, 8, ["field", "data-heap"]),
                (_unref(isMicroFrontend))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "sign-in-button",
                      onClick: _withModifiers(openSigninModal, ["prevent"])
                    }, _toDisplayString(_ctx.slice.primary.signInText), 9, _hoisted_3))
                  : (_openBlock(), _createBlock(_unref(ServerSideNavigationPrismicLink), {
                      key: 1,
                      field: _ctx.slice.primary.signInLink,
                      class: "sign-in-button",
                      "data-heap": _ctx.slice.primary.signInHeapId,
                      onClick: _withModifiers(openSigninModal, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.slice.primary.signInText), 1)
                      ]),
                      _: 1
                    }, 8, ["field", "data-heap", "onClick"]))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slice.items, (link, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `slice-link-${i}`,
              class: "link"
            }, [
              _createVNode(_unref(ServerSideNavigationPrismicLink), {
                field: link.loggedInLink,
                "data-heap": link.loggedInLinkHeapId,
                class: "header-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.loggedInTextLink), 1)
                ]),
                _: 2
              }, 1032, ["field", "data-heap"])
            ]))
          }), 128)),
          _createVNode(_unref(ServerSideNavigationPrismicLink), {
            field: _ctx.slice.primary.userDashboardLink,
            "data-heap": _ctx.slice.primary.userDashboardHeapId,
            class: "dashboard-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: getImage(_unref(userData)?.info?.photo?.absoluteUrl),
                    alt: "user-photo",
                    loading: "lazy"
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(`${_unref(userData)?.info?.firstName} ${_unref(userData)?.info?.lastName}`), 1),
                  (!_unref(isCompany)(_unref(userData).info))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.slice.primary.userDashboardText), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["field", "data-heap"])
        ]))
  ]))
}
}

})